import { useState, useEffect, useCallback } from 'react';
import { supabase } from '../lib/supabase';
import { subscribeTable } from '../lib/realtime';
import type { DailyCount } from '../lib/types';

export function useDailyStats(days = 7, companyId?: string | null) {
  const [data, setData] = useState<DailyCount[]>([]);
  const [labels, setLabels] = useState<string[]>([]);
  const [loading, setLoading] = useState(true);

  const refetch = useCallback(async () => {
    const from = new Date();
    from.setDate(from.getDate() - (days - 1));
    from.setHours(0, 0, 0, 0);

    let query = supabase
      .from('trips')
      .select('created_at, status')
      .gte('created_at', from.toISOString());
    if (companyId) query = query.eq('company_id', companyId);
    const { data: rows } = await query;

    const slots: DailyCount[] = [];
    const dayLabels: string[] = [];
    for (let i = 0; i < days; i++) {
      const d = new Date(from);
      d.setDate(d.getDate() + i);
      const label = d.toLocaleDateString('en-US', { weekday: 'short' });
      dayLabels.push(label);
      slots.push({ date: label, completed: 0, cancelled: 0, total: 0 });
    }

    for (const row of rows ?? []) {
      const d = new Date(row.created_at);
      const dayOffset = Math.floor((d.getTime() - from.getTime()) / 86400000);
      if (dayOffset >= 0 && dayOffset < days) {
        slots[dayOffset].total++;
        if (row.status === 'completed') slots[dayOffset].completed++;
        if (row.status === 'cancelled') slots[dayOffset].cancelled++;
      }
    }

    setData(slots);
    setLabels(dayLabels);
    setLoading(false);
  }, [days, companyId]);

  useEffect(() => {
    refetch();
    const unsub = subscribeTable('trips', refetch);
    return unsub;
  }, [refetch]);

  return { data, labels, loading, refetch };
}
